import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        <div className="mb-6">
          <Link to="/">
            <Button variant="ghost" size="sm" className="mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <h1 className="text-3xl font-bold text-foreground">Mentions Légales</h1>
          <p className="text-muted-foreground mt-2">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">1. Éditeur du site</h2>
            <p className="mb-4">
              <strong>Nom :</strong> Emma Burt<br />
              <strong>Statut :</strong> Auto-entrepreneur<br />
              <strong>Email :</strong> contact@get-clan.com<br />
              <strong>Site web :</strong> https://get-clan.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">2. Directeur de publication</h2>
            <p>
              Emma Burt, en qualité d'éditrice du site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">3. Hébergement</h2>
            <p className="mb-4">
              Le site est hébergé par :<br />
              <strong>Supabase Inc.</strong><br />
              970 Toa Payoh North #07-04<br />
              Singapore 318992<br />
              Site web : https://supabase.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">4. Propriété intellectuelle</h2>
            <p className="mb-4">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
              et la propriété intellectuelle. Tous les droits de reproduction sont réservés.
            </p>
            <p>
              Les marques, logos, slogans et graphismes figurant sur ce site sont la propriété exclusive 
              d'Emma Burt, sauf mention contraire.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">5. Protection des données personnelles</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi "Informatique et Libertés", 
              vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition relativement aux données 
              vous concernant.
            </p>
            <p className="mt-4">
              Pour plus d'informations, consultez notre{' '}
              <Link to="/privacy-policy" className="text-primary hover:underline">
                Politique de Confidentialité
              </Link>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">6. Cookies</h2>
            <p>
              Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. 
              Aucun cookie de traçage publicitaire n'est utilisé sans votre consentement explicite.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">7. Responsabilité</h2>
            <p className="mb-4">
              L'éditeur s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site, 
              dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
            </p>
            <p>
              L'éditeur ne peut toutefois garantir l'exactitude, la complétude et l'actualité des informations diffusées 
              sur son site, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">8. Liens hypertextes</h2>
            <p>
              Les liens hypertextes mis en place dans le cadre du présent site web en direction d'autres sites et/ou 
              de pages personnelles et d'une manière générale vers toutes ressources existantes sur Internet, 
              ne sauraient engager la responsabilité de l'éditeur.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">9. Droit applicable</h2>
            <p>
              Tant le présent site que les modalités et conditions de son utilisation sont régis par le droit français, 
              quel que soit le lieu d'utilisation. En cas de contestation éventuelle, et après l'échec de toute tentative 
              de recherche d'une solution amiable, les tribunaux français seront seuls compétents pour connaître de ce litige.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">10. Contact</h2>
            <p>
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter à l'adresse : 
              contact@get-clan.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;